import { Link } from "react-router-dom";

// Change only the optional profile parameter; preserve existing query and hash.
export function withProfileContext(path, profile) {
  if (!profile) return path;
  const hashAt = path.indexOf("#");
  const hash = hashAt >= 0 ? path.slice(hashAt) : "";
  const value = hashAt >= 0 ? path.slice(0, hashAt) : path;
  const queryAt = value.indexOf("?");
  const pathname = queryAt >= 0 ? value.slice(0, queryAt) : value;
  const params = new URLSearchParams(queryAt >= 0 ? value.slice(queryAt + 1) : "");
  params.set("profile", profile);
  return `${pathname}?${params}${hash}`;
}

export function videoPath(video, path = `/videos/${video.id || video.video_id}`) {
  const context = video.performance_context;
  return withProfileContext(path, context?.kind === "profile" ? context.creator_id : null);
}

// size: "compact" (11px, unchanged default for every other caller) or "card" (12px, T1: VideoCard grids).
export default function VideoAttribution({ video, authorLink = false, size = "compact" }) {
  const handle = video.primary_author?.handle || video.creator_handle;
  const context = video.performance_context;
  const historical = video.attribution_status !== "verified";
  const id = video.id || video.video_id;
  return <div className={`min-w-0 space-y-1 ${size === "card" ? "text-xs" : "text-[11px]"} text-muted-foreground break-words`} data-testid={`video-attribution-${id}`}>
    <div>
      {historical ? "Attribution historique non vérifiée : " : "Auteur principal : "}
      {authorLink && video.author_creator_id
        ? <Link className="underline" to={`/creators/${video.author_creator_id}`}>{handle}</Link>
        : authorLink && video.primary_author?.profile_url
          ? <a className="underline" href={video.primary_author.profile_url} target="_blank" rel="noreferrer">{handle}</a>
          : <span>{handle}</span>}
    </div>
    {context?.kind !== "profile" && video.profile_contexts?.length > 1 && <div>
      Profils associés : {video.profile_contexts.map(c => `${c.handle} (${c.role === "coauthor" ? "coauteur attesté" : c.role === "primary_author" ? "auteur principal" : "historique"})`).join(" · ")}
    </div>}
    {context?.creator_id && <div data-testid={`video-performance-context-${id}`}>
      {context.kind === "profile" ? "Profil suivi" : "Référence maximale des profils suivis"} : {context.handle}
      {context.role === "coauthor" ? " · Coauteur attesté" : context.role === "primary_author" ? " · Auteur principal" : " · Association historique"}
      {typeof context.baseline === "number" && <> · baseline {context.baseline.toLocaleString("fr-FR")} vues</>}
    </div>}
  </div>;
}
